module.exports = __webpack_public_path__ + "static/favicon-97e05d7d857b1047551ff6128702cab5.ico";